import { CalendarEvent, EVENT_TYPE_CONFIG } from "@/hooks/useCalendarEvents";
import { Button } from "@/components/ui/button";
import { Eye, Pencil } from "lucide-react";

interface Props {
  event: CalendarEvent;
  onPreview: (ev: CalendarEvent) => void;
  onEdit: (ev: CalendarEvent) => void;
}

export const EventHoverActions = ({ event, onPreview, onEdit }: Props) => {
  const cfg = EVENT_TYPE_CONFIG[event.event_type];

  return (
    <div className="p-2 space-y-2 min-w-[180px]">
      <div className="flex items-center gap-2">
        <span className="h-2 w-2 rounded-full shrink-0" style={{ backgroundColor: cfg.color }} />
        <span className="text-xs font-medium truncate">{event.title}</span>
      </div>
      <p className="text-[10px] text-muted-foreground">{cfg.label}</p>
      <div className="flex items-center gap-1 pt-1 border-t">
        <Button
          variant="ghost"
          size="sm"
          className="h-7 text-xs gap-1 flex-1"
          onClick={(e) => { e.stopPropagation(); onPreview(event); }}
        >
          <Eye className="h-3 w-3" /> Preview
        </Button>
        {!event.is_auto_generated && (
          <Button
            variant="ghost"
            size="sm"
            className="h-7 text-xs gap-1 flex-1"
            onClick={(e) => { e.stopPropagation(); onEdit(event); }}
          >
            <Pencil className="h-3 w-3" /> Edit
          </Button>
        )}
      </div>
    </div>
  );
};
